// import { configureStore } from '@reduxjs/toolkit'
// import storage from 'redux-persist/lib/storage';
// import { combineReducers } from 'redux';
// import { persistReducer } from 'redux-persist';
// import { encryptTransform } from 'redux-persist-transform-encrypt';
// import AuthSlice from '../slice/auth_slice';

// // import thunk from 'redux-thunk';
// // import FiltersSlice from '../Slices/FiltersSlice';
// // import sidebarSlice from '../Slices/sidebarSlice';

// const encryptor = encryptTransform({
//     secretKey: 'Aashish_Zimo_oevent_superAdmin',
// });
// const reducers = combineReducers({
//     auth: AuthSlice,
//     // sidebar:sidebarSlice
//     // filters:FiltersSlice
// });
// const persistConfig = {
//     key: 'root',
//     storage,
//     transforms: [encryptor],
//     blacklist: [],
//     whitelist: ["auth"],
// };
// const persistedReducer = persistReducer(persistConfig, reducers);
// const store = configureStore({
//     reducer: persistedReducer,
//     devTools: process.env.NODE_ENV !== 'production',
//     // middleware: [thunk],
// });

// export default store;


import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import AuthSlice from '../slice/auth_slice';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import LabguageSlice from '../slice/languageSlice'
import location from "../slice/location-slice";
const encryptor = encryptTransform({
  secretKey: 'Aashish_Zimo_oevent_superAdmin',
});

const reducers = combineReducers({
  auth: AuthSlice,
  language: LabguageSlice,
  location: location,
});

const persistConfig = {
  key: 'root',
  storage,
  transforms: [encryptor],
  blacklist: [],
  whitelist: ["auth", "language", "location"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export default store;
